export default {
    namespaced: true,
    state: {
        fetchData: '',
        user: '',
        password: '',
        quant: 1,
        annexation: 0,
        mainPrice: 0
    },
    mutations: {
        setUserInfo(state, payload) {
            state.user = payload.user
            state.password = payload.password
            state.fetchData = payload.fetchData
        },
        setQuant(state, payload) {
            state.quant = payload
        },
        setPrice (state, payload) {
            state.annexation = payload
        },
        setMainPrice (state, payload) {
            state.mainPrice = payload
        },
    },
    getters: {

    },
    actions: {},
    modules: {

    }
}